(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avent-bag-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('avent-bag-3d')) return;

    const TAU = Math.PI * 2;
    const clamp = (x, a, b) => Math.min(b, Math.max(a, x));
    const lerp = (a, b, t) => a + (b - a) * t;
    const smooth = (e0, e1, x) => {
      const t = clamp((x - e0) / (e1 - e0), 0, 1);
      return t * t * (3 - 2 * t);
    };
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const damp = (a, b, k, dt) => lerp(a, b, 1 - Math.exp(-k * dt));
    const DESKTOP = '(min-width: 990px)';

    /* Poids de chaque chapitre dans la hauteur de la section. */
    const WEIGHT = { intro: 1.2, matieres: 3.4, pots: 3.0, apres: 1.7, fin: 1.3 };
    /* Où atterrir quand on clique un point (position dans le chapitre). */
    const LAND = { intro: 0, matieres: 0.12, pots: 0.14, apres: 0.5, fin: 0.7 };

    /* Caméra : cible t, azimut, élévation (jamais plongeante), demi-largeur / demi-hauteur à cadrer. */
    const KF = {
      intro: { t: [0, 2.14, 0], az: 0, el: 0.07, fw: 1.15, fh: 2.3 },
      mat: [
        { t: [0.1, 1.02, 0.12], az: 0.32, el: 0.06, fw: 0.95, fh: 0.95 },
        { t: [-0.06, 2.02, 0.18], az: -0.32, el: 0.14, fw: 0.82, fh: 0.82 },
        { t: [0.22, 1.62, 0.16], az: 0.62, el: 0.1, fw: 0.82, fh: 0.82 },
        { t: [-0.04, 3.2, 0], az: -0.42, el: 0.04, fw: 1.12, fh: 1.12 },
      ],
      pots: { t: [0, 2.1, 0], az: 0, el: 0.08, fw: 2.05, fh: 2.38 },
      potsM: { t: [0, 2.12, 0], az: 0, el: 0.08, fw: 1.55, fh: 2.36 },
      apres: { t: [0, 2.14, 0], az: -0.42, el: 0.04, fw: 1.15, fh: 2.3 },
      /* Gros plan bas sur l'ouverture pendant que les baguettes glissent dedans : le nœud reste hors champ. */
      apresClose: { t: [0, 1.8, 0.05], az: -0.3, el: 0.09, fw: 0.98, fh: 0.98 },
      fin: { t: [0, 2.14, 0], az: 0.14, el: 0.05, fw: 1.15, fh: 2.3 },
    };
    const mix = (A, B, f) => ({
      t: A.t.map((v, i) => lerp(v, B.t[i], f)),
      az: lerp(A.az, B.az, f),
      el: lerp(A.el, B.el, f),
      fw: lerp(A.fw, B.fw, f),
      fh: lerp(A.fh, B.fh, f),
    });
    function camFor(preset, q, mobile) {
      if (preset === 'pots' && mobile) return KF.potsM;
      if (preset === 'matieres') {
        const m = q * 4;
        const j = Math.min(Math.floor(m), 3);
        return j < 3 ? mix(KF.mat[j], KF.mat[j + 1], smooth(0.62, 1, m - j)) : KF.mat[3];
      }
      if (preset === 'apres') return mix(KF.apres, KF.apresClose, smooth(0.28, 0.46, q));
      if (preset === 'fin') return mix(KF.apresClose, KF.fin, smooth(0.05, 0.6, q));
      return KF[preset] || KF.intro;
    }

    const LABELS = Array.from({ length: 12 }, (_, k) => `${2 * k + 1}-${2 * k + 2}`);

    class AventBag3d extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.avent-b3__track');
        this.scene = this.querySelector('.avent-b3__scene');
        this.stage = this.querySelector('[data-b3-stage]');
        this.copy = this.querySelector('.avent-b3__copy');
        this.chapWrap = this.querySelector('.avent-b3__chapters');
        this.chaps = [...this.querySelectorAll('[data-b3-chap]')];
        if (!this.track || !this.scene || !this.chaps.length) return;

        const q = new URLSearchParams(location.search).get('b3') || '';
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches || q === 'reduced';
        if (this.reduced || q === 'nogl' || !this.hasWebGL()) return; // repli : photo + chapitres empilés

        this.low = !matchMedia(DESKTOP).matches || matchMedia('(pointer: coarse)').matches || q === 'low';
        this.layout();
        this.classList.add('is-3d');
        this.buildDots();

        this.st = { p: 0, pS: 0, i: -1, mat: -1, day: -1, spin: 0, user: 0, vel: 0, lastUser: -1e9, enter: 0 };
        this.on = [];
        const listen = (target, type, fn, opts) => {
          target.addEventListener(type, fn, opts);
          this.on.push(() => target.removeEventListener(type, fn, opts));
        };

        this.ro = new ResizeObserver(() => this.resize());
        this.ro.observe(this.scene);
        this.ro.observe(this.chapWrap);

        /* Boucle seulement quand la section est (presque) à l'écran. */
        this.visible = false;
        this.io = new IntersectionObserver(([e]) => {
          this.visible = e.isIntersecting;
          this.toggleLoop();
        }, { rootMargin: '200px 0px' });
        this.io.observe(this.track);
        listen(document, 'visibilitychange', () => this.toggleLoop());

        /* Module 3D (Three.js inclus) : téléchargé quand la section approche. */
        this.ioLoad = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          this.ioLoad.disconnect();
          this.loadModule();
        }, { rootMargin: '600px 0px' });
        this.ioLoad.observe(this.track);

        /* Barre d'achat sticky du thème (bloc ai_gen_block_dab08ee) : quand elle est
           visible en bas d'écran, on remonte la carte de texte et on recadre le sac. */
        this._dock = -1;
        const updDock = () => {
          const d = document.querySelector('[class*="ai-sticky-atc"]');
          let h = 0;
          if (d && d.classList.contains('visible')) {
            const r = d.getBoundingClientRect();
            if (r.height && r.top < window.innerHeight) h = Math.round(window.innerHeight - r.top);
          }
          if (h !== this._dock) {
            this._dock = h;
            this.style.setProperty('--b3-dock', h + 'px');
            this.resize();
            setTimeout(() => this.resize(), 320);
          }
        };
        let dockRaf = 0;
        listen(window, 'scroll', () => { if (!dockRaf) dockRaf = requestAnimationFrame(() => { dockRaf = 0; updDock(); }); }, { passive: true });
        listen(window, 'resize', updDock);
        const dockEl = document.querySelector('[class*="ai-sticky-atc"]');
        if (dockEl) {
          const mo = new MutationObserver(updDock);
          mo.observe(dockEl, { attributes: true, attributeFilter: ['class', 'style'] });
          this.on.push(() => mo.disconnect());
        }
        updDock();

        /* Glisser horizontalement pour tourner (le défilement vertical reste natif : touch-action pan-y). */
        if (this.dataset.drag === 'true') {
          let drag = null;
          listen(this.stage, 'pointerdown', (e) => {
            if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
            drag = { id: e.pointerId, x: e.clientX };
            this.st.vel = 0;
            if (e.pointerType === 'mouse') e.preventDefault();
          });
          listen(window, 'pointermove', (e) => {
            if (!drag || e.pointerId !== drag.id) return;
            const dx = e.clientX - drag.x;
            drag.x = e.clientX;
            this.st.user += dx * 0.009;
            this.st.vel = dx * 0.009;
            this.st.lastUser = performance.now();
            this.hintOff = true;
          });
          const end = () => {
            drag = null;
          };
          listen(window, 'pointerup', end);
          listen(window, 'pointercancel', end);
          this.dragging = () => !!drag;
          const hint = this.querySelector('[data-b3-hint]');
          const hintBox = this.querySelector('.avent-b3__hint');
          if (hint && hintBox && hintBox.dataset.hintTouch && matchMedia('(pointer: coarse)').matches) {
            hint.textContent = hintBox.dataset.hintTouch;
          }
        }

        /* Points de progression, CTA, focus clavier, éditeur de thème. */
        listen(this.querySelector('[data-b3-dots]'), 'click', (e) => {
          const b = e.target.closest('button[data-i]');
          if (b) this.goTo(+b.dataset.i);
        });
        const cta = this.querySelector('[data-b3-cta]');
        if (cta) listen(cta, 'click', (e) => this.onCta(e));
        listen(this.chapWrap, 'focusin', (e) => {
          const c = e.target.closest('[data-b3-chap]');
          const i = this.chaps.indexOf(c);
          if (i >= 0 && i !== this.st.i) this.goTo(i, true);
        });
        listen(document, 'shopify:block:select', (e) => {
          const i = this.chaps.findIndex((c) => c.contains(e.target) || c === e.target);
          if (i >= 0) this.goTo(i, true);
        });
        listen(document, 'shopify:section:unload', (e) => {
          if (e.target && e.target.contains(this)) this.teardown();
        });

        this.resize();
        this.tick(performance.now(), true);
      }

      disconnectedCallback() {
        this.teardown();
      }

      hasWebGL() {
        try {
          const c = document.createElement('canvas');
          const gl = c.getContext('webgl2') || c.getContext('webgl');
          if (!gl) return false;
          const lose = gl.getExtension('WEBGL_lose_context');
          if (lose) lose.loseContext();
          return true;
        } catch (e) {
          return false;
        }
      }

      /* Découpe 0 → 1 en chapitres, au prorata de leur poids. */
      layout() {
        const presets = this.chaps.map((c) => c.dataset.preset || 'intro');
        const w = presets.map((p) => WEIGHT[p] || 1.4);
        const total = w.reduce((a, b) => a + b, 0);
        let acc = 0;
        this.ranges = presets.map((preset, i) => {
          const a = acc / total;
          acc += w[i];
          return { preset, a, b: acc / total };
        });
        this.potsIdx = presets.indexOf('pots');
        this.apresIdx = presets.indexOf('apres');
        this.mats = [...this.querySelectorAll('[data-b3-mat]')];
        this.dayEl = this.querySelector('[data-b3-day]');
        this.pips = [...this.querySelectorAll('[data-b3-pips] i')];
        this.hintEl = this.querySelector('.avent-b3__hint');
      }

      buildDots() {
        const nav = this.querySelector('[data-b3-dots]');
        if (!nav) return;
        nav.innerHTML = '';
        this.dots = this.chaps.map((c, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.dataset.i = i;
          b.setAttribute('aria-label', `${i + 1}. ${c.dataset.nav || ''}`);
          b.title = c.dataset.nav || '';
          nav.appendChild(b);
          return b;
        });
      }

      /* Zone libre où cadrer le sac : à droite du texte (desktop), au-dessus de la carte (mobile). */
      resize() {
        if (!this.scene) return;
        const W = this.scene.clientWidth;
        const H = this.scene.clientHeight;
        const sr = this.scene.getBoundingClientRect();
        let f;
        if (matchMedia(DESKTOP).matches) {
          const cr = this.chapWrap.getBoundingClientRect();
          const x = Math.max(cr.right - sr.left + 24, W * 0.36);
          const right = W - Math.max(72, (W - Math.min(W, 1600)) / 2 + 56);
          f = { x, y: 76, w: Math.max(200, right - x), h: H - 76 - 78 - Math.max(0, this._dock || 0) };
        } else {
          /* La carte du chapitre actif est calée en bas : le sac occupe l'espace au-dessus. */
          const cr = this.chapWrap.getBoundingClientRect();
          this.cardsBottom = cr.bottom - sr.top;
          this.cardH = this.chaps.map((c) => c.offsetHeight);
          const bottom = clamp(cr.top - sr.top - 8, H * 0.42, H);
          f = { x: 8, y: 58, w: W - 44, h: bottom - 58 };
        }
        this.mobile = !matchMedia(DESKTOP).matches;
        this.fDyn = null;
        if (this.st && this.st.i >= 0) this.setChapter(this.st.i);
        this.frame = f;
        this.W = W;
        this.H = H;
        const st = this.scene.style;
        st.setProperty('--b3-fx', `${f.x}px`);
        st.setProperty('--b3-fy', `${f.y}px`);
        st.setProperty('--b3-fw', `${f.w}px`);
        st.setProperty('--b3-fh', `${f.h}px`);
        if (this.r3) this.r3.resize(W, H, f);
        this.needsRender = true;
      }

      progress() {
        const r = this.track.getBoundingClientRect();
        const scrollable = this.track.offsetHeight - this.scene.offsetHeight;
        return scrollable > 0 ? clamp(-r.top / scrollable, 0, 1) : 0;
      }

      toggleLoop() {
        const run = this.visible && document.visibilityState === 'visible' && this.isConnected;
        if (run && !this.raf) {
          this.last = performance.now();
          this.raf = requestAnimationFrame((t) => this.tick(t));
        } else if (!run && this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = 0;
        }
      }

      tick(now, once) {
        if (!once) this.raf = 0;
        const s = this.st;
        if (!s) return;
        const dt = Math.min(0.1, Math.max(0, (now - (this.last || now)) / 1000));
        this.last = now;
        const p = this.progress();
        const snap = Math.abs(p - s.pS) > 0.3 || once;
        s.pS = snap ? p : damp(s.pS, p, 8, dt);
        s.p = p;

        /* Chapitre courant + position locale q. */
        const R = this.ranges;
        let i = R.length - 1;
        for (let k = 0; k < R.length; k++) {
          if (s.pS < R[k].b) {
            i = k;
            break;
          }
        }
        const cur = R[i];
        const q = clamp((s.pS - cur.a) / (cur.b - cur.a), 0, 1);
        if (i !== s.i) this.setChapter(i);

        /* État du récit (fonction pure du scroll). */
        const pots = this.potsIdx;
        const jarsF = pots < 0 ? 0 : i > pots ? 12 : i === pots ? clamp((q - 0.1) / 0.8, 0, 1) * 12 : 0;
        const ap = this.apresIdx;
        const gone = ap < 0 ? 0 : i > ap ? 1 : i === ap ? smooth(0.02, 0.4, q) : 0;
        const loaves = ap < 0 ? 0 : i > ap ? 1 : i === ap ? clamp((q - 0.42) / 0.5, 0, 1) : 0;
        const matF = cur.preset === 'matieres' && q > 0.04 ? q * 4 : -1;

        /* Matière active (liste) et compteur des pots. */
        const mat = matF < 0 ? -1 : Math.min(3, Math.floor(matF));
        if (mat !== s.mat) {
          s.mat = mat;
          this.mats.forEach((li) => li.classList.toggle('is-on', +li.dataset.b3Mat === mat));
        }
        let out = 0;
        for (let k = 0; k < 12; k++) if (jarsF >= k * (10.5 / 11) + 0.75) out = k + 1;
        if (out !== s.day) {
          s.day = out;
          if (this.dayEl) this.dayEl.textContent = LABELS[Math.max(out, 1) - 1];
          this.pips.forEach((pip, k) => pip.classList.toggle('is-out', k < out));
        }

        /* Caméra : fondu depuis la sortie du chapitre précédent. */
        let cam = camFor(cur.preset, q, this.mobile);
        if (i > 0) {
          const tr = cur.preset === 'matieres' ? 0.06 : 0.16;
          if (q < tr) cam = mix(camFor(R[i - 1].preset, 1, this.mobile), cam, smooth(0, tr, q));
        }

        /* Rotation : un tour complet sur le chapitre d'ouverture (+ rotation lente à l'arrêt), puis de face. */
        const idle = now - s.lastUser > 2500 && !(this.dragging && this.dragging());
        const isIntro = cur.preset === 'intro';
        const spinOK = isIntro && q < 0.75 && this.dataset.autorotate === 'true';
        if (spinOK) s.spin += dt * 0.28;
        else s.spin = damp(s.spin, Math.round(s.spin / TAU) * TAU, 2.2, dt);
        if (!this.dragging || !this.dragging()) {
          s.user += s.vel;
          s.vel *= Math.pow(0.9, dt * 60);
          if (idle) s.user = damp(s.user, Math.round(s.user / TAU) * TAU, 1.6, dt);
        }
        const introYaw = isIntro ? easeOut(q) * TAU : 0;
        const yaw = introYaw + s.spin + s.user;

        if (this.hintEl) this.hintEl.classList.toggle('is-off', !isIntro || q > 0.6 || !!this.hintOff);

        if (this.r3 && this.mobile && this.cardH) {
          const f = this.frame;
          const target = clamp(this.cardsBottom - this.cardH[i] - 10, f.y + f.h, this.H * 0.8) - f.y;
          if (!this.fDyn || snap) this.fDyn = { x: f.x, y: f.y, w: f.w, h: target };
          const h = damp(this.fDyn.h, target, 5, dt);
          if (Math.abs(h - this.fDyn.h) > 0.25 || snap) {
            this.fDyn.h = snap ? target : h;
            this.r3.setFrame(this.fDyn);
          }
        }

        if (this.r3) {
          if (this.ready) s.enter = Math.min(1, s.enter + dt / 1.1);
          if (!this.facesAsked && (pots < 0 || s.pS > R[pots].a - 0.12)) {
            this.facesAsked = true;
            this.r3.loadFaces();
          }
          this.r3.render({
            cam,
            yaw,
            lift: (1 - easeOut(s.enter)) * 0.5,
            jarsF,
            gone,
            loaves,
            matF,
            time: now / 1000,
            dt,
            snap,
          });
          if (!this.ready) {
            this.ready = true;
            this.classList.add('is-ready');
          }
        }
        if (!once) this.toggleLoop();
      }

      setChapter(i) {
        this.st.i = i;
        if (this.mobile && this.cardH && this.scene) {
          this.scene.style.setProperty('--b3-hy', `${Math.round(this.cardsBottom - this.cardH[i] - 50)}px`);
        }
        this.chaps.forEach((c, k) => c.classList.toggle('is-active', k === i));
        (this.dots || []).forEach((d, k) => {
          if (k === i) d.setAttribute('aria-current', 'step');
          else d.removeAttribute('aria-current');
        });
      }

      goTo(i, instant) {
        const r = this.ranges && this.ranges[i];
        if (!r) return;
        const p = r.a + (r.b - r.a) * (LAND[r.preset] || 0.2);
        const scrollable = this.track.offsetHeight - this.scene.offsetHeight;
        const top = window.scrollY + this.track.getBoundingClientRect().top + p * scrollable;
        window.scrollTo({ top: Math.round(top), behavior: instant || this.reduced ? 'instant' : 'smooth' });
      }

      onCta(e) {
        const target = document.querySelector(
          'product-form-component button[name="add"], form[data-type="add-to-cart-form"] button[type="submit"]'
        );
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(() => target.focus({ preventScroll: true }), 650);
      }

      async loadModule() {
        if (this.r3 || this.loading || !this.dataset.module) return;
        this.loading = true;
        try {
          const mod = await import(this.dataset.module);
          if (!this.isConnected || !this.st) return;
          const tag = (k) => this.querySelector(`[data-b3-tag="${k}"]`);
          const lid = this.dataset.lid || '';
          const face = this.dataset.face || '';
          this.r3 = mod.createScene({
            host: this.stage,
            lidUrl: (n) => lid.replace('{n}', n),
            faceUrl: (n) => face.replace('{n}', n),
            volant: this.dataset.volant,
            low: this.low,
            reduced: this.reduced,
            tags: { velours: tag('velours'), carreaux: tag('carreaux'), volant: tag('volant'), ruban: tag('ruban') },
            label: this.dataset.label,
            onLost: () => this.fallback(),
          });
          this.resize();
          this.tick(performance.now(), true);
        } catch (err) {
          console.warn('[avent-bag-3d] 3D indisponible, photo affichée.', err);
          this.fallback();
        } finally {
          this.loading = false;
        }
      }

      /* Plus de 3D : on rend la section à sa forme simple (photo + chapitres). */
      fallback() {
        this.teardown();
        this.classList.remove('is-3d', 'is-ready');
        this.chaps.forEach((c) => c.classList.remove('is-active'));
      }

      teardown() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
        if (this.on) this.on.forEach((off) => off());
        this.on = [];
        if (this.io) this.io.disconnect();
        if (this.ioLoad) this.ioLoad.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.r3) {
          try {
            this.r3.dispose();
          } catch (e) {
            /* rien à libérer */
          }
        }
        this.r3 = null;
        this.st = null;
        this.ready = false;
      }
    }

    customElements.define('avent-bag-3d', AventBag3d);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avent-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('avent-before-after')) return;
    const REDUCED = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class AventBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('.avent-ba__frame');
        if (!this.frame) return;
        this.range = this.frame.querySelector('.avent-ba__range');
        this.dates = [...this.querySelectorAll('.avent-ba__dates button')];
        this.lb = this.dataset.labelBefore || '';
        this.la = this.dataset.labelAfter || '';
        this.pos = Number(this.dataset.start) || 50;
        this.touched = false;
        this.raf = 0;

        let drag = false;
        let decided = false;
        let sx = 0;
        let sy = 0;
        const fromEvent = (e) => {
          const r = this.frame.getBoundingClientRect();
          return ((e.clientX - r.left) / r.width) * 100;
        };
        this.frame.addEventListener('pointerdown', (e) => {
          drag = true;
          decided = e.pointerType === 'mouse';
          sx = e.clientX;
          sy = e.clientY;
          this.touched = true;
          cancelAnimationFrame(this.raf);
          if (decided) {
            this.frame.setPointerCapture(e.pointerId);
            this.set(fromEvent(e));
          }
        });
        this.frame.addEventListener('pointermove', (e) => {
          if (!drag) return;
          if (!decided) {
            const dx = Math.abs(e.clientX - sx);
            const dy = Math.abs(e.clientY - sy);
            if (dx + dy < 6) return;
            /* geste vertical : on laisse défiler la page */
            if (dy > dx) {
              drag = false;
              return;
            }
            decided = true;
            this.frame.setPointerCapture(e.pointerId);
          }
          this.set(fromEvent(e));
        });
        const end = () => {
          drag = false;
        };
        this.frame.addEventListener('pointerup', end);
        this.frame.addEventListener('pointercancel', end);
        this.range.addEventListener('input', () => {
          this.touched = true;
          this.set(Number(this.range.value));
        });
        this.dates.forEach((b) =>
          b.addEventListener('click', () => {
            this.touched = true;
            this.tween(Number(b.dataset.go));
          })
        );
        this.set(this.pos);

        if (this.dataset.hint !== 'true' || REDUCED() || !('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver(
          ([entry], obs) => {
            if (!entry.isIntersecting || this.touched) return;
            obs.disconnect();
            const seq = [
              [32, 550],
              [68, 750],
              [this.pos, 550],
            ];
            let i = 0;
            const next = () => {
              if (this.touched || i >= seq.length) return;
              const [to, ms] = seq[i++];
              this.tween(to, ms);
              setTimeout(next, ms + 60);
            };
            next();
          },
          { threshold: 0.6 }
        );
        this.io.observe(this.frame);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        if (this.io) this.io.disconnect();
      }

      set(v) {
        this.pos = Math.max(0, Math.min(100, v));
        const p = Math.round(this.pos);
        this.frame.style.setProperty('--pos', `${this.pos}%`);
        this.frame.style.setProperty('--posn', this.pos.toFixed(1));
        this.range.value = String(p);
        this.range.setAttribute(
          'aria-valuetext',
          this.pos > 95 ? this.lb : this.pos < 5 ? this.la : `${p} % ${this.lb}, ${100 - p} % ${this.la}`
        );
        if (this.dates.length === 2) {
          this.dates[0].setAttribute('aria-pressed', String(this.pos > 95));
          this.dates[1].setAttribute('aria-pressed', String(this.pos < 5));
        }
      }

      tween(to, ms = 700) {
        cancelAnimationFrame(this.raf);
        if (REDUCED()) {
          this.set(to);
          return;
        }
        const from = this.pos;
        const t0 = performance.now();
        const step = (now) => {
          const t = Math.min(1, (now - t0) / ms);
          const e = 1 - Math.pow(1 - t, 3);
          this.set(from + (to - from) * e);
          if (t < 1) this.raf = requestAnimationFrame(step);
        };
        this.raf = requestAnimationFrame(step);
      }
    }

    customElements.define('avent-before-after', AventBeforeAfter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avent-lid-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('avent-lid-grid')) return;

    const REDUCED = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Dévissage : rotation −330°, levée, bascule en Y ; d = 1 (vers la droite) ou −1 (dernière colonne). */
    const openKF = (d) => [
      { transform: 'translate3d(0,0,0) rotateY(0) rotateX(0) rotateZ(0)' },
      { transform: 'translate3d(0,0,8px) rotateY(0) rotateX(0) rotateZ(-210deg)', offset: 0.42 },
      { transform: `translate3d(${4 * d}%,-10%,70px) rotateY(${-10 * d}deg) rotateX(14deg) rotateZ(-300deg)`, offset: 0.68 },
      { transform: `translate3d(${48 * d}%,-14%,40px) rotateY(${-62 * d}deg) rotateX(6deg) rotateZ(-330deg)` },
    ];
    const shadowKF = (d) => [
      { transform: 'translate(0,3%) scale(1)', opacity: 0.5 },
      { transform: 'translate(0,3%) scale(1)', opacity: 0.5, offset: 0.42 },
      { transform: `translate(${8 * d}%,6%) scale(.92)`, opacity: 0.28, offset: 0.68 },
      { transform: `translate(${44 * d}%,4%) scale(.5,.95)`, opacity: 0.3 },
    ];
    const FADE = [{ opacity: 1 }, { opacity: 0 }];

    class AventLidGrid extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.avent-lg__grid');
        this.cells = this.grid ? [...this.grid.children] : [];
        this.body = this.querySelector('.avent-lg__panel-body');
        this.countEl = this.querySelector('[data-lg-count]');
        this.resetBtn = this.querySelector('.avent-lg__reset');
        this.anims = new Map();
        this.lines = (this.dataset.lines || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
        if (!this.lines.length) this.lines = ['?'];

        this.cells.forEach((cell) => {
          const btn = cell.querySelector('.avent-lg__lid');
          if (btn) btn.addEventListener('click', () => this.toggle(cell));
        });
        if (this.resetBtn) {
          this.resetBtn.addEventListener('click', () => {
            this.cells.forEach((c) => this.toggle(c, false, true));
            this.say(this.dataset.resetK || '', this.dataset.resetT || '');
          });
        }
        this.querySelectorAll('[data-lg-dir]').forEach((b) =>
          b.addEventListener('click', () => this.scrollLabels(Number(b.dataset.lgDir)))
        );
      }

      disconnectedCallback() {
        this.anims.forEach((a) => a.forEach((x) => x.cancel()));
        this.anims.clear();
      }

      side(cell) {
        const cols = getComputedStyle(this.grid).gridTemplateColumns.split(' ').length;
        return this.cells.indexOf(cell) % cols === cols - 1 ? -1 : 1;
      }

      say(k, t) {
        if (!this.body) return;
        const write = () => {
          this.body.replaceChildren();
          const pk = document.createElement('p');
          pk.className = 'avent-lg__k';
          pk.textContent = k;
          const pt = document.createElement('p');
          pt.className = 'avent-lg__t';
          pt.textContent = t;
          this.body.append(pk, pt);
          this.body.classList.remove('is-swapping');
        };
        this.body.classList.add('is-swapping');
        if (REDUCED()) write();
        else setTimeout(write, 160);
      }

      count() {
        const n = this.grid.querySelectorAll('.is-open').length;
        const total = Number(this.dataset.total) || this.cells.length || 1;
        if (this.countEl) this.countEl.textContent = String(n);
        this.style.setProperty('--lg-p', String(n / total));
        if (this.resetBtn) this.resetBtn.hidden = n === 0;
      }

      toggle(cell, force, silent) {
        const btn = cell.querySelector('.avent-lg__lid');
        const isOpen = cell.classList.contains('is-open');
        const open = force ?? !isOpen;
        if (open === isOpen || !btn) return;

        const d = this.side(cell);
        let a = this.anims.get(cell);
        if (a && a.d !== d && !isOpen) {
          a.forEach((x) => x.cancel());
          a = null;
        }
        if (!a) {
          const cap = cell.querySelector('.avent-lg__cap');
          const sh = cell.querySelector('.avent-lg__shadow');
          const reduced = REDUCED();
          const opt = { duration: reduced ? 250 : 1300, easing: 'cubic-bezier(.65,0,.25,1)', fill: 'both' };
          a = reduced
            ? [cap.animate(FADE, opt), sh.animate(FADE, opt)]
            : [cap.animate(openKF(d), opt), sh.animate(shadowKF(d), opt)];
          a.forEach((x) => x.pause());
          a.d = d;
          this.anims.set(cell, a);
        }
        cell.classList.add('is-animating');
        a.forEach((x) => {
          x.playbackRate = open ? 1 : -1;
          x.play();
        });
        a[0].onfinish = () => cell.classList.remove('is-animating');
        cell.classList.toggle('is-open', open);

        const when = btn.dataset.when || '';
        btn.setAttribute('aria-pressed', String(open));
        btn.setAttribute('aria-label', `${open ? this.dataset.rescrew : this.dataset.unscrew} · ${when}`);
        this.count();
        if (silent) return;

        if (open) {
          const teaser = cell.dataset.teaser || this.lines[this.cells.indexOf(cell) % this.lines.length];
          this.say(`${when} · ${this.dataset.opened || ''}`.trim(), teaser);
        } else {
          this.say(when, this.dataset.closed || '');
        }
      }

      scrollLabels(dir) {
        const track = this.querySelector('.avent-lg__track');
        const first = track && track.firstElementChild;
        if (!first) return;
        const w = first.getBoundingClientRect().width + 6;
        track.scrollBy({ left: dir * w * 2, behavior: REDUCED() ? 'auto' : 'smooth' });
      }
    }

    customElements.define('avent-lid-grid', AventLidGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
